export const DATA = [
	{
		projectName: "Email Sorter",
		url: "https://github.com/gracexichen/emailSorter",
		description:
			"Retrieves 10 newest unread emails, displaying simple information (from, subject, date), with a one sentences summary",
		image: "./email-sorter.png",
	},
	{
		projectName: "Microjet Detection",
		url: "https://github.com/gracexichen/microjetdetection",
		description:
			"Uses OpenCV to analyze liquid microjets for sample delivery methods, accurately determining properties such as jet length, jet width, droplet radius, and droplet speed",
		image: "./microjet-detection.png",
	},
];
